import React from 'react';
import LandingApp from '../landing/App';

const LandingPage = () => {
    return <LandingApp />;
};

export default LandingPage;
